<template>
    <!-- 打印出库申请单界面 -->
  <div>
      <div>
      <img style="margin-left:20px" id='qrcode' v-bind:src="src">
      <p class="p-font">出库申请单</p>
      </div>

      <div >

           <p class="p-title">
                编号:{{responseData.number}}
            </p>
            <p class="p-title">
                客户:{{responseData.customer}}
            </p>
            <p class="p-title">
                联系电话:{{responseData.customerPhone}}
            </p>
            <p class="p-title">
                出库数量:{{responseData.categoryCount}}
            </p>
            <p class="p-title">出库时间:{{this.utils.timestampToTime(this.responseData.outboundTime,2)}}</p>
            </div>
  <div>
      <table border="1px" style="border-collapse: collapse;border-spacing: 0; ">
        <tbody>
        <tr class="two">
            <td  width="300" class="smallFont-title" valign="top" style="word-break: break-all;">
                卷布名称
            </td>
            <td  width="300" class="smallFont-title" valign="top" style="word-break: break-all;">
                幅宽(毫米)
            </td>
            <td  width="300" class="smallFont-title" valign="top" style="word-break: break-all;">
                重量(千克)
            </td>
            <td  width="300" class="smallFont-title" valign="top" style="word-break: break-all;">
                参考长度(米)
            </td>
        </tr>
        <tr v-for="(item,index) in list" :key="index">
            <td  width="300" class="smallFont"  valign="top" style="word-break: break-all;">
                <span style="color: rgb(32, 33, 36); font-family: consolas, &quot;lucida console&quot;, &quot;courier new&quot;, monospace; font-size: 15px;">{{item.productName}}</span>
            </td>
            <td  width="300" class="smallFont" valign="top" style="word-break: break-all;">
                <span style="color: rgb(32, 33, 36); font-family: consolas, &quot;lucida console&quot;, &quot;courier new&quot;, monospace; font-size: 15px;">{{item.doorWidth}}</span>
            </td>
            <td  width="300" class="smallFont" valign="top" style="word-break: break-all;">
                <span style="color: rgb(32, 33, 36); font-family: consolas, &quot;lucida console&quot;, &quot;courier new&quot;, monospace; font-size: 15px;">{{item.weight}}</span>
            </td>
            <td  width="300" class="smallFont" valign="top" style="word-break: break-all;">
                <span style="color: rgb(32, 33, 36); font-family: consolas, &quot;lucida console&quot;, &quot;courier new&quot;, monospace; font-size: 15px;">{{item.length}}</span>
            </td>
        </tr>
    </tbody>
</table>
</div>
    <div class="div-middle">
      <p class="p">仓库负责人</p>
      <p class="p">出库经手人</p>
      <p class="p">记账</p>
      </div>
  </div>
</template>

<script>
import AraleQRCode from 'arale-qrcode'
export default {
    data() {
        return {
            responseData: [],
            list: [],
            null: [{ productName: '暂无数据', doorWidth: '暂无数据', weight: '暂无数据', length: '暂无数据' }]
            }
    },
    methods: {
        // 生成二维码
        bulid() {
            const result = new AraleQRCode({
                render: 'svg', /*  生成的类型 'svg' or 'table dom元素类型 */
                text: this.responseData.number, /* 二维码的链接 */
                size: 65 /* 二维码的大小 */
            })
            const svgXml = new XMLSerializer().serializeToString(result)
            this.src = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(svgXml)))
        }
    },
    created() {
        this.responseData = this.$route.query
        this.list = JSON.parse(this.$route.query.list)
        if (this.list.length === 0) this.list = this.null
        console.log(this.responseData)
        this.bulid()
        window.print()
        // window.close()
    }
}
</script>

<style>
.div-middle{
    vertical-align: middle;
    text-align: center;
}
.smallFont {
  text-align: center;
  vertical-align: middle;
}
.smallFont-title {
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
}
.p{
   display: inline;
   margin:50px;
   font-weight: bold;
}
.p-title{
   font-weight: bold;
   display: inline;
   margin:10px
}
.p-font{
    display: inline;
    font-weight: bold;
    font-size: 30px;
    margin-left: 220px;
}
</style>
